import type { ReactNode } from "react"

import { ErrorBoundary } from "@/app/error-boundary"
import { ErrorState, LoadingState } from "@/components/kit/states"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

/**
 * One region of the overview (LLD §9.3): its own skeleton, its own error with
 * a retry, and its own boundary, so one failure never blanks the others.
 */
export function Region({
  title,
  action,
  query,
  skeleton = "detail",
  children,
  className,
}: {
  title: string
  action?: ReactNode
  query: { isPending: boolean; error: unknown; refetch: () => unknown }
  skeleton?: "detail" | "table"
  children: () => ReactNode
  className?: string | undefined
}) {
  return (
    <Card className={className}>
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2">
        <CardTitle>
          <h2 className="text-base font-semibold">{title}</h2>
        </CardTitle>
        {action}
      </CardHeader>
      <CardContent>
        <ErrorBoundary>
          {query.error ? (
            <ErrorState error={query.error} onRetry={() => void query.refetch()} />
          ) : query.isPending ? (
            <LoadingState variant={skeleton} rows={3} />
          ) : (
            children()
          )}
        </ErrorBoundary>
      </CardContent>
    </Card>
  )
}
